import React from 'react';
import { ButtonProps, Button } from 'pounceV2';
import LinkButtonWrapperV3, { LinkButtonWrapperPropsV3 } from '../utils/LinkButtonWrapperV3';

export type LinkButtonPropsV3 = LinkButtonWrapperPropsV3 & Omit<ButtonProps, 'as'>;

export const LinkButtonV3: React.FC<LinkButtonPropsV3> = ({
  disabled,
  external,
  to,
  target,
  children,
  ...rest
}) => {
  return (
    <LinkButtonWrapperV3 disabled={disabled} external={external} to={to} target={target}>
      <Button
        type={null}
        aria-disabled={disabled}
        sx={{ whiteSpace: 'nowrap' }}
        component="span"
        {...rest}
      >
        {children}
      </Button>
    </LinkButtonWrapperV3>
  );
};
